import {createContext} from "react";
import {CartContextType, CartItemBase} from "./ShoppingCartContextTypes";

const defaultContext: CartContextType<any> = {
  cart: [],
  addProductToCart: () => {},
  removeProductFromCart: () => {},
  loading: false,
}

export function CreateCartContext<TItemType extends CartItemBase>() {
  return createContext < CartContextType < TItemType >> (defaultContext)
}

export const contextObject = CreateCartContext();
